export default {
  namespaced: true,
  state: () => ({
    notas: [],
    select: [],
    setIsLoading: false,
    filterList: {},
  }),
  actions: {},
  mutations: {
    SET_NOTAS(state, data) {
      state.notas = data;
    },
    SET_SELECT(state, data) {
      state.select = data;
    },
    SET_IS_LOADING(state, data) {
      state.setIsLoading = data;
    },
    SET_FILTROS(state, data) {
      state.filterList = data;
    },
  },
  getters: {
    getNotas: (state) => state.notas,
    getSelect: (state) => state.select,
    getIsLoading: (state) => state.setIsLoading,
    getFilterList: (state) => state.filterList,
  },
};
